// routes
import { ToastContainer } from 'react-toastify';
import Router from './routes';
// theme
import ThemeConfig from './theme';
import GlobalStyles from './theme/globalStyles';
// components
import ScrollToTop from './components/ScrollToTop';
import { BaseOptionChartStyle } from './components/charts/BaseOptionChart';
import CustomeErrorMessage from './components/CustomErrorMessage';
import CustomLoader from './components/CustomLoader';
import 'react-toastify/dist/ReactToastify.css';

// ----------------------------------------------------------------------

export default function App() {
  return (
    <ThemeConfig>
      <ScrollToTop />
      <GlobalStyles />
      <BaseOptionChartStyle />
      <Router />
      <CustomeErrorMessage /> {/* show error message */}
      <CustomLoader /> {/* Custom Loader */}
      <ToastContainer />
    </ThemeConfig>
  );
}
